module.exports = __webpack_public_path__ + "catalog/items/dining/alternative-dining-table-for-4/alternative-dining-table-for-4.svg";